import type { ThemeState } from "../administration/designManager/themeSlice";

// Logo of the network-level theme, as shown in the header. An unsaved
// local override (design manager preview) points at the asset preview.
export function themeLogoUrl(theme: ThemeState): string | undefined {
  return theme.override
    ? `/api/storage/assets/${theme.logoImage?.id}/preview`
    : theme.logoUrl;
}
